type DownloadIconProps = {
  size?: number;
};

function DownloadIcon({ size = 14 }: DownloadIconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M7.25 1.5h1.5v7.19l2.22-2.22 1.06 1.06L8 11.56 3.97 7.53l1.06-1.06 2.22 2.22V1.5ZM2 12.5h1.5V14h9v-1.5H14V15.5H2v-3Z" />
    </svg>
  );
}

export default DownloadIcon;
